import {extendTheme} from '@chakra-ui/react';
import {mode} from "@chakra-ui/theme-tools"
import {themecolors} from "../utils/themecolors";

const FormLabel = {
    baseStyle: (props) => ({
        fontSize: "14px",
        fontWeight: '600',
        color: mode(`${themecolors.light_high_impact_text} !important`, `${themecolors.dark_high_impact_text} !important`)(props),
    }),
};

const Form = {
    baseStyle: (props) => ({
        helperText: {
            color: mode(themecolors.light_medium_impact_text, themecolors.dark_medium_impact_text)(props),
        },
    }),
};

const Alert = {
    baseStyle: {
        title: {
            fontWeight: 500,
        },
    },
};

const Button = {
    baseStyle: (props) => ({
        color: '#fff',
        bg: '#3182ce',
    }),
    variants: {
        subscribe: (props) => ({
            fontSize: '14px',
            fontWeight: 500,
            height: '28px',
            bg: mode('#1974e4', '#f3f3f3')(props),
            borderRadius: '6px',
            padding: '0 18px',
            color: mode('#fff', '#1e1e1e')(props),
            _hover: {
                bg: mode('#1656d1', '#fff')(props),
            }
        }),
        subscribed: (props) => ({
            fontSize: '14px',
            fontWeight: 500,
            height: '28px',
            bg: mode('#dedfe6', '#272728')(props),
            borderRadius: '6px',
            padding: '0 18px',
            color: mode('#1e1e1e', '#fff')(props),
            _hover: {
                bg: mode('#d2d4da', '#2d2d2e')(props),
            }
        }),
        blue: (props) => ({
            fontSize: '16px',
            fontWeight: 500,
            height: '42px',
            bg: mode('#0c0c0c', '#f3f3f3')(props),
            borderRadius: '6px',
            padding: '0 24px',
            color: mode('#fff', themecolors.light_high_impact_text)(props),
            _hover: {
                bg: mode('#0c0c0c', '#fff')(props),
                _disabled: {
                    bg: mode('#363636', '#fff')(props),
                }
            }
        }),
        grey: (props) => ({
            fontSize: '16px',
            fontWeight: 500,
            height: '42px',
            bg: mode(themecolors.lighter_border, '#272728')(props),
            borderRadius: '6px',
            padding: '0 24px',
            color: mode(themecolors.light_high_impact_text, themecolors.dark_high_impact_text)(props),
            _hover: {
                bg: mode(themecolors.light_border, '#2d2d2e')(props),
                _disabled: {
                    bg: mode('#d2d4da', '#2d2d2e')(props),
                }
            }
        }),
        cancel: (props) => ({
            color: mode(themecolors.light_low_impact_text, themecolors.dark_low_impact_text)(props),
            bg: 'transparent',
            padding: '0 12px',
            fontSize: '15px',
            fontWeight: '500',
        }),
        viewArchive: (props) => ({
            fontSize: '13px',
            fontWeight: 500,
            bg: mode('#ececec', '#272728')(props),
            borderRadius: '6px',
            padding: '0 20px',
            height: '34px',
            color: mode('#1e1e1e', '#fff')(props),
            _hover: {
                bg: mode('#d2d4da', '#2d2d2e')(props),
            }
        }),
        save: (props) => ({
            color: '#fff',
            bg: '#307ad5',
            borderRadius: 50,
            fontWeight: 500,
            padding: '0 24px',
            _hover: {
                _disabled: {
                    bg: '#3182ce',
                },
            },
        }),
        save2: (props) => ({
            color: '#000',
            fontSize: '14px',
            fontWeight: 'normal',
            bg: '#f7f7f7',
            padding: '0 24px',
            borderRadius: '40px',
            _hover: {
                _disabled: {
                    bg: '#3182ce',
                },
            },
        }),
        none: (props) => ({
            color: 'black',
            bg: 'none',
        }),
        support: (props) => ({
            fontSize: '15px',
            bg: mode('#f6f7f6', '#343536')(props),
            color: mode('rgb(94 97 101)', '#fff')(props),
            _hover: {
                bg: mode('#eaeaea', '#424345')(props),
            }
        }),
    },
};

const Menu = {
    baseStyle: (props) => ({
        list: {
            color: mode('inherit', '#fff'),
            bg: mode('white', '#1a1a1b')(props),
            border: mode('1px solid #e2e8f0', '1px solid #343536')(props),
        },
    }),
};

const Modal = {
    baseStyle: (props) => ({
        dialog: {
            color: mode('inherit', '#fff'),
            bg: mode('white', '#1a1a1b')(props),
            border: mode('none', '1px solid #343536')(props),
        },
    }),
};

const Tag = {
    variants: {
        topic: (props) => {
            return {
                container: {
                    bg: mode('rgba(0, 0, 0, .05)', '#282828')(props),
                }
            };
        }
    },
    defaultProps: {
        variant: "topic"
    }
};

const Input = {
    baseStyle: (props) => ({
        field: {
            _placeholder: {
                color: mode(themecolors.light_medium_impact_text, themecolors.dark_medium_impact_text)(props),
            },
        },
    }),
    variants: {
        outline: (props) => ({
            field: {
                borderColor: mode(themecolors.light_border, themecolors.dark_background_5)(props),
            }
        })
    },
    sizes: {
        md: {
            field: {
                borderRadius: '8px',
                padding: '20px 16px',
            },
        },
    },
};

const NumberInput = {
    variants: {
        outline: (props) => ({
            field: {
                fontSize: '15px',
                borderColor: mode(themecolors.light_border, themecolors.dark_background_5)(props),
            },
        }),
    },
    sizes: {
        md: {
            field: {
                borderRadius: '8px',
            },
        },
    },
};

const Select = {
    variants: {
        outline: (props) => ({
            field: {
                fontSize: '15px',
                borderColor: mode(themecolors.light_border, themecolors.dark_background_5)(props),
            },
        }),
    },
    sizes: {
        md: {
            field: {
                borderRadius: '8px',
            },
        },
    },
};

const Textarea = {
    baseStyle: (props) => ({
        _placeholder: {
            color: mode(themecolors.light_medium_impact_text, themecolors.dark_medium_impact_text)(props),
        },
    }),
    variants: {
        outline: (props) => ({
            borderColor: mode(themecolors.light_border, themecolors.dark_background_5)(props),
        })
    },
    sizes: {
        md: {
            borderRadius: '8px',
            padding: '12px 16px',
        },
    },
};


export default extendTheme({
    colors: {
        gray: {
            50: "#f9f9f9",
            100: "#f2f2f2",
            200: "#e5e5e5",
            300: "#d4d4d4",
            400: "#a3a3a3",
            500: "#737373",
            600: "#525252",
            700: "#404040",
            800: "#262626",
            900: "#171717",
        },
    },
    fonts: {
        heading: 'Inter',
        body: 'Inter',
    },
    styles: {
        global: (props) => ({
            body: {
                bg: mode('#fff', themecolors.dark_background_1)(props),
            },
        }),
    },
    components: {
        Alert,
        FormLabel,
        Modal,
        Button,
        Menu,
        Tag,
        Input,
        Select,
        Textarea,
        Form,
        NumberInput
    },
});
